import axios from 'axios';
const user = JSON.parse(localStorage.getItem("user"));
console.log(user);
const TOKEN_KEY = user?.token;

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password,
    });
    console.log("Login response:", response.data);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
      'An error occurred during login. Please try again.'
    );
  }
}

export const logout = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;

    const response = await axios.post(`${API_URL}/auth/logout`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Logout failed:', error);
    throw error.response?.data?.message || 'An error occurred during logout. Please try again.';
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};
